import * as moment from 'moment';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Permiso_notariadoComponent = /** @class */ (function () {
    function Permiso_notariadoComponent(_formService, fb) {
        this._formService = _formService;
        this.fb = fb;
        this.rows = [];
        this.maxDate = moment().toDate();
        this.form = new FormGroup({
            acreditacion: new FormControl(''),
            fecha: new FormControl({ value: '', disabled: true }),
            escritura: new FormControl({ value: '', disabled: true }),
            notario: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("permiso_notariado"))) {
            localStorage.setItem("permiso_notariado", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("permiso_notariado"));
            this.form.controls['fecha'].setValue(this.rows[0] ? moment(this.rows[0].fecha, "DD/MM/YYYY").toDate() : null);
            this.form.controls['acreditacion'].setValue(this.rows[0] ? this.rows[0].acreditacion : '');
            this.form.controls['escritura'].setValue(this.rows[0] ? moment(this.rows[0].fecha, "DD/MM/YYYY").toDate() : null);
            this.form.controls['notario'].setValue(this.rows[0] ? this.rows[0].notario : '');
        }
    }
    Permiso_notariadoComponent.prototype.add_permiso_notariado = function (event, type) {
        if (event) {
            if (type == "input" || type == "change") {
                this.fecha = moment(event.value).format('DD/MM/YYYY');
            }
            if (type == "input2" || type == "change2") {
                this.escritura = moment(event.value).format('DD/MM/YYYY');
            }
        }
        else {
            var temp = JSON.parse(localStorage.getItem("permiso_notariado"));
            if (temp[0]) {
                console.log(temp);
                this.fecha = temp[0].fecha;
                this.escritura = temp[0].escritura;
            }
            else {
                this.fecha = '',
                    this.escritura = '';
            }
        }
        localStorage.setItem("permiso_notariado", JSON.stringify([]));
        this.actualRow = localStorage.getItem("permiso_notariado");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            acreditacion: this.form.value.acreditacion,
            fecha: this.fecha,
            escritura: this.escritura,
            notario: this.form.value.notario
        });
        /*this.rows = this.rows.concat({
            acreditacion: this.form.value.acreditacion,
            fecha: this.form.value.fecha,
            escritura: this.form.value.escritura,
           // fecha: moment(this.form.value.fecha).format("DD/MM/YYYY"),
            //escritura: moment(this.form.value.escritura).format("DD/MM/YYYY"),
            notario : this.form.value.notario
        })*/
        localStorage.setItem("permiso_notariado", JSON.stringify(this.rows));
    };
    Permiso_notariadoComponent.prototype.delete_permiso_notariado = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("permiso_notariado", JSON.stringify(this.rows));
            }
        }
    };
    return Permiso_notariadoComponent;
}());
export { Permiso_notariadoComponent };
